module.exports = __webpack_public_path__ + "static/blocker-google-calendar-cc24be58e7f2fb1603185fba40872d30.mp4";